import React from "react";
import { Button, Table } from "@mui/joy";
import { Util } from "../Helpers/Util";
import ElevatorDialog from "../Dialogs/ElevatorDialog";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";

interface ElevatorListingProps {
	buildingId: string;
}

interface Elevator {
	address1: string;
	address2: string;
	buildings_id: string;
	city: string;
	days_since_last_maint: number;
	description: string;
	elevators_id: string;
	out_of_service: string;
	serial_number: string;
	state: string;
	track_maintenance: boolean;
	type: string;
	zip: string;
}

export default function ElevatorListing(props: ElevatorListingProps) {
	const [elevators, setElevators] = React.useState([] as Array<Elevator>);
	const [dialog, setDialog] = React.useState(false);
	const [eId, setEid] = React.useState("");

	React.useEffect(() => {
		getData();
	}, [props.buildingId]);

	const getData = () => {
		fetch("Building/GetElevators", {
			method: "Post",
			cache: "no-cache",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ buildingsId: props.buildingId }),
		})
			.then((x) => x.json())
			.then((x) => setElevators(x as Array<Elevator>));
	};

	return (
		<>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				{dialog && (
					<ElevatorDialog
						buildingsId={props.buildingId}
						elevatorsId={eId}
						close={() => {
							getData();
							setDialog(false);
						}}
					/>
				)}
				<Button
					sx={{ marginTop: 1 }}
					onClick={() => {
						setEid("");
						setDialog(true);
					}}>
					Add Elevator
				</Button>
				<Table stripe="even" hoverRow>
					<thead>
						<tr>
							<th>Serial #</th>
							<th>Days Since Last Maint.</th>
							<th>Type</th>
							<th>Street Address</th>
							<th>City</th>
							<th>State</th>
							<th>Zip</th>
							<th>Track Maint.?</th>
							<th>Out of Service?</th>
						</tr>
					</thead>
					<tbody>
						{elevators.map((x) => {
							return (
								<tr
									style={{ cursor: "pointer" }}
									onClick={() => {
										setDialog(true);
										setEid(x.elevators_id);
									}}>
									<td>{x.serial_number}</td>
									<td>{x.days_since_last_maint}</td>
									<td>{x.type}</td>
									<td>{x.address1}</td>
									<td>{x.city}</td>
									<td>{x.state}</td>
									<td>{x.zip}</td>
									<td>{Util.Formatter(x.track_maintenance, "L")}</td>
									<td>{x.out_of_service}</td>
								</tr>
							);
						})}
					</tbody>
				</Table>
			</LocalizationProvider>
		</>
	);
}
